export enum ImageFit {
	Contain = "Contain",
	Cover = "Cover",
}
